---
title: Email i konfiguracja skrzynki pocztowej
parent: Dokumentacja
parentHref: /docs
---

# Konfiguracja skrzynki pocztowej email

Plan TOBY obejmuje profesjonalny adres email zgodny z domeną (na przykład info@twoja-domena.de) ze **skrzynką pocztową o pojemności 15 GB (Maxi-Postfach)** oraz nieograniczoną liczbą adresów przekierowujących. Potrzebują Państwo więcej skrzynek lub dodatkowej przestrzeni? Mogą Państwo w każdej chwili dodać kolejną skrzynkę 15 GB — zobacz [cennik](/pl/pricing).

## 1. Tworzenie skrzynki pocztowej w TOBY

1. Otwórz **Ustawienia → Email** w TOBY.
2. Wybierz żądany adres (np. info@, hello@ lub contact@) i utwórz skrzynkę pocztową.
3. **Skopiuj hasło:** TOBY wyświetla wygenerowane hasło do skrzynki pocztowej tylko raz, zaraz po jej utworzeniu. Skopiuj lub zapisz je przed zamknięciem okna. (Jeśli kiedykolwiek je zgubią Państwo, mogą wygenerować nowe hasło jednym kliknięciem w **Ustawienia → Email** — istniejące wiadomości pozostaną bezpieczne.)

## 2. Odczytywanie i wysyłanie emaili w przeglądarce (Webmail)

Mogą Państwo otworzyć skrzynkę odbiorczą z dowolnej przeglądarki komputerowej lub telefonu bez instalowania aplikacji:

- **Adres Webmail:** [mail.tobysite.com/SOGo](https://mail.tobysite.com/SOGo)
- **Nazwa użytkownika:** pełny adres email (np. info@twoja-domena.de)
- **Hasło:** hasło do skrzynki pocztowej z **Ustawienia → Email**

## 3. Podłączanie telefonu lub komputera (IMAP i SMTP)

Aby odczytywać i wysyłać emaile w **Apple Mail (iPhone, iPad, Mac)**, **Gmail / Android Mail**, **Outlook** lub **Thunderbird**, dodaj nowe konto **IMAP** w aplikacji pocztowej i wprowadź następujące ustawienia serwera:

| Ustawienie | Wartość |
| --- | --- |
| **Typ konta** | IMAP |
| **Adres email / Nazwa użytkownika** | Pełny adres email (np. info@twoja-domena.de) |
| **Hasło** | Hasło do skrzynki pocztowej z Ustawienia → Email |
| **Serwer poczty przychodzącej (IMAP)** | mail.tobysite.com |
| **Port przychodzący** | 993 (SSL/TLS) |
| **Serwer poczty wychodzącej (SMTP)** | mail.tobysite.com |
| **Port wychodzący** | 465 (SSL/TLS) lub 587 (STARTTLS) |

> **Ważne:** Upewnij się, że wprowadzają Państwo **pełny adres email** (z @twoja-domena.de) jako nazwę użytkownika dla **obu** serwerów — przychodzącego (IMAP) i wychodzącego (SMTP).

### Krok po kroku na iPhone i iPad (iOS Mail)

1. Otwórz aplikację **Ustawienia** na iPhone → **Aplikacje** → **Mail** → **Konta Mail** → **Dodaj konto** → **Inne** → **Dodaj konto Mail**.
2. Wprowadź swoje imię i nazwisko, pełny adres email, hasło do skrzynki pocztowej oraz krótki opis. Stuknij **Dalej**.
3. Pozostaw zaznaczony **IMAP** u góry.
4. W sekcji **Serwer poczty przychodzącej** i **Serwer poczty wychodzącej** wprowadź mail.tobysite.com jako Nazwa hosta, pełny adres email jako Nazwa użytkownika oraz hasło do skrzynki pocztowej.
5. Stuknij **Dalej**, a następnie **Zapisz**.

### Krok po kroku na Android (aplikacja Gmail)

1. Otwórz aplikację **Gmail**, stuknij zdjęcie profilowe w prawym górnym rogu → **Dodaj kolejne konto** → **Inne**.
2. Wprowadź pełny adres email i stuknij **Konfiguracja ręczna** → **Osobiste (IMAP)**, następnie wprowadź hasło.
3. Dla **Serwera poczty przychodzącej** ustaw serwer na mail.tobysite.com, port 993 oraz typ zabezpieczeń SSL/TLS.
4. Dla **Serwera SMTP poczty wychodzącej** ustaw serwer na mail.tobysite.com, port 465 (SSL/TLS) i upewnij się, że **Wymagaj logowania** jest włączone z pełnym adresem email.
5. Stuknij **Dalej**, aby zakończyć.

Dalej: [Newsletter i ogłoszenia](/pl/docs/newsletter).
